module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/LTE1-74b893a0cedf934bc44ad7705f9b6bcf.svg";